import {EmojiObjectsOutlined,QuestionMark,HelpOutline,Message,Dashboard,Insights,Send, Settings,AppRegistration, AccountCircle, QueryStats,PieChartOutlineRounded, ShowChart,Add, Search} from '@mui/icons-material/';
import MonitorHeartOutlined from '@mui/icons-material/MonitorHeartOutlined';

const aboutDialogData = [
  {
    headline: "What is this tool?",
    paragraphs: [
      "This tool is designed to analyze coin holders and provide insights into the distribution of top holders.",
    ],
  },
  {
    headline: "How to read it?",
    paragraphs: [
      "Supply ---> Ammount of supply displayed in the chart",
      "Bar Mcap ---> Each buy from selected top holders is put in it's range",
      "Color ---> When did buy happen?",
      "Net transfers --->SUM (Transfers in are positive out are negative)"
    ],
  },
  {
    headline: "How does sell reflect on visualization?",
    paragraphs: [
      "If top holder bought 3 times then sold, tokens sold are substracted form each position in relative manner."
    ],
  },
  {
    headline: "Sometime age maps are missing",
    paragraphs: [
      "Some swaps are harder to track token > token. Empty age map means some errors in processing.",
      "If you see many age maps missing in table take data with 'grain of salt'. Its partial data."
    ],
  },
];

export default aboutDialogData;


export const links = [
    {
      title: 'Home',
      links: [
        {
          name: 'Dashboard',
          icon: <Dashboard/>,
        },
      ],
    },
  
    {
      title: 'Tools',
      links: [
        {
          name: 'Structure info',
          icon: <PieChartOutlineRounded  />,
        },
        {
          name: 'SceneBuilder',
          icon: <AppRegistration />,
        },
        {
          name: 'SyncLogs',
          icon: <MonitorHeartOutlined />,
        },
      ],
    },
    {
      title: 'CV',
      links: [
        {
          name: 'CV',
          icon: <Message  />,
        }
      ],
    },
    {
      title: 'General',
      links: [
        {
            name: 'About',
            icon: <HelpOutline />,
        }
      ],
    },
  ];

  export const aboutData = {
    General: {
      headline: "General",
      icon: <QuestionMark fontSize="large" />,
      paragraphs: [
        "Vision Tools is a project specially made for hosting any type of tool.",
        "There is a database and login system ready.",
      ],
      texts: [
        `> Only those who need to see data can see it.
  
  > Very easy to hide/restrict sensitive data.
  
  > Always interested in understanding the underlying nature of things.
  
  > Deliver straightforward tools that provide general-purpose advantages.`,
      ],
    },
    Philosophy: {
      headline: "Philosophy",
      icon: <QuestionMark fontSize="large" />,
      paragraphs: [
        "After many hours watching Sol memecoins, Ante had an enlightening moment...",
      ],
      texts: [
        `> One end is how much you need, and the other is how much you currently possess.
  
  > Like each pumpfun coin, the idea of richness is exponential on both sides.
  
  > If you chase only one side, you might feel you have much less compared to working on both sides.
  
  > Always open for a good conversation.`,
      ],
    },
    Data_Design: {
    headline: "Data_Design",
    icon: <EmojiObjectsOutlined fontSize="large" />,
    paragraphs: [
      "I like data sets and good design",
    ],
    texts: [
    `
    > Feel free to reach out.

    > Good design makes data more honest, not less.

    > The best tools are both rigorous and easy to look at.`,
    ],
  },
    Collaboration: {
      headline: "Market view",
      icon: <QuestionMark fontSize="large" />,
      paragraphs: [
        "Does not look the best to me at the moment. Okay long-term.",
        "Warren Buffett sits on cash. Trump's behavior is hard to price in.",
      ],
      texts: [
        `> Inflation (CPI) is not going away quickly.
  
  > Biggest risks: Trump invading Greenland, more tariffs and responses (short-term pain).
  
  > Still, long-term money will be printed as always, and interest rates need to be lowered.
  
  > 3–6 months of pain, then bullish.`,
      ],
    },
  };
  
  